"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabletMinWidth = exports.tabletMaxWidth = exports.mobileMaxWidth = exports.desktopMinWidth = exports.desktopMaxWidth = exports.default = void 0;
var mobileMaxWidth = exports.mobileMaxWidth = 623;
var tabletMinWidth = exports.tabletMinWidth = 624;
var tabletMaxWidth = exports.tabletMaxWidth = 1020;
var desktopMinWidth = exports.desktopMinWidth = 1021;
var desktopMaxWidth = exports.desktopMaxWidth = 1440;
var _default = () => ({
  global: {
    lrgDesktopMinWidth: '1441px',
    desktopMaxWidth: "".concat(desktopMaxWidth, "px"),
    desktopMinWidth: "".concat(desktopMinWidth, "px"),
    tabletMaxWidth: "".concat(tabletMaxWidth, "px"),
    tabletMinWidth: "".concat(tabletMinWidth, "px"),
    mobileMaxWidth: "".concat(mobileMaxWidth, "px"),
    mobileMinWidth: '0px',
    pageBodyWidth: '1020px'
  }
});
exports.default = _default;